const product_types = {
    ADD_NEW_PRODUCT_START: 'ADD_NEW_PRODUCT_START',
    FETCH_PRODUCT_START: 'FETCH_PRODUCT_START',
    SET_PRODUCT: 'SET_PRODUCT'
}

export default product_types